/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';

export interface ITextInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    value?: string;
    required?: boolean;
    placeholder?: string;
    labelColor?: string;
    errorText?: string;
    groupText?: string;
    disabled?: boolean;
    hasError?: boolean;
    onCompChange?(id: string, payload: any): void;
}

export const TextInput = ({
    id,
    fontScale,

    label,
    value,
    errorText,
    required,
    disabled,
    placeholder,
    groupText,
    onCompChange,
    labelColor,
    hasError,
}: ITextInputProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => setTextValue(value ?? ''), [value]);
    console.log('3985734895insidetweety', id, textValue, value);
    console.log(`isError::`, hasError);
    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
        if (!hasError) {
            if (isInvalid) {
                setInvalid(false);
            }
        }
    }, [hasError]);
    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    document.querySelectorAll('.tweety-form .input-group')?.forEach((ele) => {
        ele?.addEventListener('', (e) => {
            console.log(e, 'mati->');
        });
    });
    // console.log('hiu->',document
    // .querySelector(`#input-${id}:focus`));
    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });

    return (
        <>
            <Form.Group
                id={id}
                className="formgroup"
                style={{ backgroundColor: disabled ? '#F5F5F5' : '#fff' }}
            >
                {_renderLabelIf()}
                <InputGroup id={`input-group-${id}`} className="input-group-bt">
                    {groupText && (
                        <InputGroup.Text id="basic-addon1">
                            {groupText}
                        </InputGroup.Text>
                    )}
                    <S.FormControl
                        fontScale={fontScale}
                        className="formcontrol input shadow-none"
                        id={`input-${id}`}
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={required}
                        disabled={disabled}
                        type="text"
                        placeholder={placeholder}
                        isInvalid={isInvalid}
                        style={{
                            backgroundColor: disabled ? '#F5F5F5' : '#fff',
                        }}
                    />
                </InputGroup>
                <InputGroup>{_renderErrorTextIf()}</InputGroup>
            </Form.Group>
        </>
    );
};

TextInput.defaultProps = {
    required: false,
    disabled: false,
    hasError: false,
};
